import httpService from '@Utils/httpService';

const baseUrl = 'api/TaskTypes';

export default {
  get(params) {
    return httpService.get({
      url: baseUrl,
      params,
    });
  },
  getByUser(params) {
    return httpService.get({
      url: `${baseUrl}/ByUser`,
      params,
    });
  },
  getByFacilityId(facilityId) {
    return httpService.get({
      url: `${baseUrl}/ByFacility/${facilityId}`,
    });
  },
  getById(id) {   
    return httpService.get({
      url: `${baseUrl}/${id}`,
    });
  },
  update(data) {
    if (!data.id) return this.add(data);
    return httpService.put({
      url: `${baseUrl}/${data.id}`,
      data,
    });
  },
  add(data) {
    return httpService.post({
      url: baseUrl,
      data,
    });
  },
  del(id) {
    return httpService.delete({
      url: `${baseUrl}/${id}`,
    });
  },
  sectionIsUsed(id) {
    return httpService.get({
      url: `${baseUrl}/sections/${id}/IsUsed`,
    });
  },
  delSection(id) {
    return httpService.delete({
      url: `${baseUrl}/sections/${id}`,
    });
  },
};
